define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/config",
	"csi/enums",
	"csi/form/Widget",
	"csi/html",
	"csi/xml"
], function(array,declare,domClass,config,enums,Widget,html,xml) {

var
	ACTIVITY_LEVEL 		= "ActivityLevel",
	ACTIVITY_TYPE 		= "ActivityType",
	AUTOCOMPLETE_EXPR	= "AutocompleteExpression",
	COMPLETE_ALL 		= "CompleteAll",
	TRACKING_TYPE 		= "TrackingType",
	TRACKING_SUB_TYPE 	= "TrackingSubType",
	TRACKING_SUBTYPE 	= "TrackingSubtype",
	TRACKING_PHASE 		= "TrackingPhase",
	TRACKING_STATE 		= "TrackingState",
	PREDECESSORS 		= "Predecessors";

	return declare(Widget, {
		// Boolean: make sure to reset appropriate fields if switching activity types
		bWriteVisible: false,

		// Object: map of attributes to expressions indicating if should be hidden

		getFieldStore: function(/*csi.def.Field*/field, /*String*/value) {
			// summary: special handling for some stores
			var trackingType = this._getTrackingType();
			var	store;

			if (field.m_id == TRACKING_SUB_TYPE) {
				// build sub-type field based on current tracking type
				store = enums.getStore(trackingType && trackingType.SubType ? trackingType.SubType : "NoTrackingSubType");
			} else if (field.m_id == TRACKING_SUBTYPE) {
				// build subtype field based on current tracking type
				store = this._getTrackableSubtypes(trackingType);
			} else if (field.m_id == TRACKING_STATE) {
				// special handling for tracking types with own states
				store = enums.getStore(field.getEnumId(), null, function(v) {
					return !xml.enumGetText(v) || (trackingType && (array.indexOf(trackingType.TrackingStates, v) >= 0));
				});
			}
			
			store = store || this.inherited(arguments);

			if (field.m_id == PREDECESSORS) {
				// omit current node from predecessor store
				var	node = this.getViewNode();
				if (node) {
					store.idOmit = node.$URL;
				}
			}

			return store;
		},

		_buildView: function() {
			// summary: make sure calendar is in cache to resolve queries
			this.cacheView.cacheNode(this.defView.m_formData.getParent());
			this.inherited(arguments);
		},

		_getFieldSelectRootURL: function(field) {
			// summary: all queries but phases are reletive to Calendar
			return (field.m_id == TRACKING_PHASE) ? this.inherited(arguments) : this.defView.m_formData.getParent().$URL;
		},

		_getActivityType: function() {
			// summary: return currently selected tracking type
			return this.defView.getFieldValue(ACTIVITY_TYPE);
		},

		_getTrackableSubtypes: function(trackingType) {
			// summary: return subtypes of currently selected calendar tracking type
			return trackingType ? config.getSubtypeStore(trackingType.$Name) : null;
		},

		_getTrackingType: function() {
			// summary: return currently selected tracking type
			return this.cacheView.getNode(this.defView.getFieldValue(TRACKING_TYPE), true);
		},

		_updateFieldVisibility: function(/*csi.def.Field?*/field) {
			// summary: reset hidden field values
			var	changed = this.inherited(arguments);

			var activityType = this._getActivityType();
			var trackingType = this._getTrackingType();
			var trackableSubtypes = this._getTrackableSubtypes(trackingType);

			changed |= this.setFieldHidden(ACTIVITY_LEVEL, activityType != 'ACTIVITYTYPE:Activity' && activityType != 'ACTIVITYTYPE:ExpressionActivity');
			changed |= this.setFieldHidden(AUTOCOMPLETE_EXPR, activityType != 'ACTIVITYTYPE:ExpressionActivity');
			changed |= this.setFieldHidden(COMPLETE_ALL,   activityType != 'ACTIVITYTYPE:TrackActivity');
			changed |= this.setFieldHidden(TRACKING_TYPE,  activityType != 'ACTIVITYTYPE:TrackActivity');
			changed |= this.setFieldHidden(PREDECESSORS,   activityType != 'ACTIVITYTYPE:Milestone');

			changed |= this.setFieldHidden(TRACKING_SUB_TYPE,	!trackingType || !trackingType.SubType);
			changed |= this.setFieldHidden(TRACKING_SUBTYPE,   !trackingType || !trackableSubtypes);
			changed |= this.setFieldHidden(TRACKING_STATE, 	!trackingType || !trackingType.TrackingStates.length);
			changed |= this.setFieldHidden(TRACKING_PHASE, 	!trackingType || !trackingType.TrackingPhases.length);

			// FIX: not exactly sure why this is needed?
			// [YG]: To reset the user selected value, so next time field become visible, it has initial value
			if (changed) {
				array.forEach(this.defView.m_fields, function(f) {
					if (!this.isFieldVisible(f)) {
						this.setFieldValue(f, f.m_rca.getValue());
					}
				}, this);
			}

			return changed;
		},

		setFieldHidden: function(/*String|Field*/field, /*Boolean*/bHide) {
			if (typeof field === "string")
				field = this.defView.getField(field);

			if (!field)
				return false;

			var row = this.getFieldRow(field);
			if (!row)
				return false;

			if (bHide == domClass.contains(row, html.CSS_HIDE))
				return false;


			domClass.toggle(row, html.CSS_HIDE, bHide);
			return true;
		}
	});
});